import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { LoadingComponent } from "../components/LoadingComponent";
import { getDB } from "../util/db";
import { setNavAdvisoryLockout } from "../util/utils";

export function ComponentTypeListPage(props) {
	setNavAdvisoryLockout(false);

	let [ctypes, setCtypes] = useState(null);

	let isLoading = (ctypes == null);
	useEffect(async () => {
		if(isLoading) {
			let db = await getDB();
			setCtypes(await db.getAll("ComponentTypes"));
		}
	})

	if(isLoading) {
		return <LoadingComponent />;
	}
	return <div>
		<h1>Component Types</h1>
		<ul>
			{ctypes.map(ctype => <li key={ctype.id}>
				<Link to={`/componentTypes/${ctype.id}`}>{ctype.name}</Link>
			</li>)}
		</ul>
		<Link to="/componentTypes/new"><Button>New Component Type</Button></Link>
	</div>;
}